let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iCaUz")).then(() => parcelRequire('dKfJw'));